import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

const snqComponent = [
  { title: 'navigation.catalog', path: paths.catalog },
  { title: 'navigation.equivalency', path: paths.equivalency },
  { title: 'navigation.rvcc', path: paths.rvcc },
  { title: 'navigation.square', path: paths.square },
];

const snqComponentMobile = [
  {
    order: '1',
    items: [{ title: 'navigation.catalog', path: paths.catalog }],
  },
  {
    order: '2',
    items: [{ title: 'navigation.equivalency', path: paths.equivalency }],
  },
  {
    order: '3',
    items: [{ title: 'navigation.rvcc', path: paths.rvcc }],
  },
  {
    order: '4',
    items: [{ title: 'navigation.square', path: paths.square }],
  },
];

export const navConfig = [
  { title: 'navigation.home', path: '/' },
  { title: 'navigation.ucsnq', path: paths.ucsnq },
  {
    title: 'navigation.snq',
    path: paths.snq,
  },
  {
    title: 'navigation.snq_component',
    path: paths.catalog,
    children: [snqComponent[0], snqComponent[1], snqComponent[2], snqComponent[3]],
  },
  {
    title: 'navigation.document',
    path: paths.document,
  },
  {
    title: 'navigation.news',
    path: paths.news,
  },
  {
    title: 'navigation.contact',
    path: paths.contact,
  },
];

export const navConfigMobile = [
  { title: 'navigation.home', path: '/' },
  { title: 'navigation.ucsnq', path: paths.ucsnq },
  {
    title: 'navigation.snq',
    path: paths.snq,
  },
  {
    title: 'navigation.snq_component',
    path: paths.catalog,
    children: [
      snqComponentMobile[0],
      snqComponentMobile[1],
      snqComponentMobile[2],
      snqComponentMobile[3],
    ],
  },
  {
    title: 'navigation.document',
    path: paths.document,
  },
  {
    title: 'navigation.news',
    path: paths.news,
  },
  {
    title: 'navigation.contact',
    path: paths.contact,
  },
];
